export default {
      id: "info-usage",
      viewBox: "0 0 14.886 14.886",
      url: __webpack_public_path__ + "svg/sprite.svg#info",
      toString: function () {
        return this.url;
      }
    }